<template>
  <div>
    <md-toolbar
      id="toolbar"
      md-elevation="0"
      class="md-fixed"
      :class="{
        [`md-${type}`]: !navbarTransparent,
        [extraNavClasses]: navbarTransparent,
        'md-transparent': navbarTransparent
      }"
      :color-on-scroll="colorOnScroll">
      <div class="md-toolbar-row md-collapse-lateral">
        <div class="md-toolbar-section-start">
          <router-link to="/"><img class="logo" :src="logo"/></router-link>
          <h3 class="md-title">{{ brand }}</h3>
        </div>
        <div class="md-toolbar-section-end">
          <md-button
            class="md-just-icon md-simple md-toolbar-toggle"
            :class="{ toggled: toggledClass }"
            @click="toggleNavbarMobile()"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <div class="md-collapse">
            <div class="md-collapse-wrapper">
              <mobile-menu nav-mobile-section="false">
                <!-- Here you can add your items from the section-start of your toolbar -->
              </mobile-menu>
              <md-list>
                <li class="md-list-item">
                  <router-link to="/#about"
                    class="md-list-item-router md-list-item-container md-button-clean dropdown"
                  >
                    <div class="md-list-item-content md-ripple">
                        About Us
                    </div>
                  </router-link>
                </li>
                <li class="md-list-item">
                  <router-link to="/products"
                    class="md-list-item-router md-list-item-container md-button-clean dropdown"
                  >
                    <div class="md-list-item-content md-ripple">
                        Products
                    </div>
                  </router-link>
                </li>
                <li class="md-list-item">
                  <router-link to="/#contact"
                    class="md-list-item-router md-list-item-container md-button-clean dropdown"
                  >
                    <div class="md-list-item-content md-ripple">
                        Contact
                    </div>
                  </router-link>
                </li>
                <li class="md-list-item">
                  <div class="md-list-item-content">
                    <md-button
                      v-if="!isAuthenticated"
                      @click="loginModal=true"
                      class="md-warning md-round">
                      Login
                    </md-button>
                     <drop-down v-else direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-simple dropdown-toggle"
                        data-toggle="dropdown">
                        <md-icon style="font-size: 32px!important;">account_circle</md-icon>
                      </md-button>
                      <ul class="dropdown-menu">
                        <li>
                            <p class="account-name">{{ accountName }}</p>
                        </li>
                        <li>
                          <a href="#" @click="logout">
                            <p>Log out</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </li>
              </md-list>
            </div>
          </div>
        </div>
      </div>
    </md-toolbar>
    <div class="modal modal-bg" :class="{ show: loginModal }">
      <modal
        modal-with-card
        header-card-color="green"
        type="modal-login"
        card-classes="md-card-login"
        v-if="loginModal"
        @close="loginModal = false"
      >
        <template slot="header">
          <md-card-header class="md-card-header-green">
            <md-button
              class="md-simple md-white md-close md-just-icon md-round modal-default-button"
              @click="loginModal = false"
            >
              <md-icon>clear</md-icon>
            </md-button>
            <h4 class="card-title">Sign in to your account</h4>
          </md-card-header>
        </template>

        <template slot="body">
          <form>
            <md-field class="md-form-group" slot="inputs">
              <md-icon>email</md-icon>
              <label>Email</label>
              <md-input v-model="login.email" autocomplete="email" type="email"></md-input>
            </md-field>
            <md-field class="md-form-group" slot="inputs">
              <md-icon>lock_outline</md-icon>
              <label>Password</label>
              <md-input
                v-model="login.password"
                autocomplete="current-password"
                type="password">
              </md-input>
            </md-field>
            <div class="error text-center">{{ loginFormError }}</div>
          </form>
        </template>
        <template slot="footer">
          <md-button
            class="md-success md-lg"
            @click="fetchLoginToken">
            Login
          </md-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import jwt_decode from 'jwt-decode';
import { Query, Mutation } from '@/graphql';
import apollo from '@/services/apollo-graphql';

import MobileMenu from '@/layout/MobileMenu.vue';
import { Modal } from '@/components';

let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}
export default {
  components: {
    MobileMenu,
    Modal,
  },
  props: {
    type: {
      type: String,
      default: 'dark',
      validator(value) {
        return [
          'white',
          'default',
          'primary',
          'danger',
          'success',
          'warning',
          'info',
          'dark',
        ].includes(value);
      },
    },
    colorOnScroll: {
      type: Number,
      default: 0,
    },
    navbarTransparent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logo: require('@/assets/img/logo.png'),
      isAuthenticated: false,
      login: {
        email: null,
        password: null,
      },
      loginFormError: null,
      loginModal: false,
      extraNavClasses: '',
      toggledClass: false,
      brand: 'Flag Sand & Gravel',
      accountName: '',
    };
  },
  async created() {
    this.checkAuthentication();
    const token = localStorage.getItem(process.env.VUE_APP_JWT_TOKEN_KEYNAME);
    const { firstName, lastName } = jwt_decode(token);
    this.accountName = `${firstName} ${lastName}`;
  },
  methods: {
    async fetchLoginToken() {
      this.loginFormError = null;
      try {
        const response = await apollo.mutate({
          mutation: Mutation.getAccessToken,
          variables: { email: this.login.email, password: this.login.password },
        });
        localStorage.setItem(process.env.VUE_APP_JWT_TOKEN_KEYNAME, response.data.getAccessToken);
        this.$router.go();
      } catch (error) {
        const errorMessage = error.message || error;
        this.loginFormError = errorMessage.replace('GraphQL error:', '');
      }
    },
    logout() {
      localStorage.removeItem(process.env.VUE_APP_JWT_TOKEN_KEYNAME);
      apollo.cache.reset();
      this.$router.go();
    },
    async checkAuthentication() {
      const response = await apollo.query({
        query: Query.isAuthenticated,
        variables: { token: localStorage.getItem(process.env.VUE_APP_JWT_TOKEN_KEYNAME) || '' },
      });
      this.isAuthenticated = response.data.isAuthenticated;
    },
    bodyClick() {
      let bodyClick = document.getElementById('bodyClick');

      if (bodyClick === null) {
        const body = document.querySelector('body');
        const elem = document.createElement('div');
        elem.setAttribute('id', 'bodyClick');
        body.appendChild(elem);

        bodyClick = document.getElementById('bodyClick');
        bodyClick.addEventListener('click', this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      const scrollValue = document.body.scrollTop || document.documentElement.scrollTop;
      const navbarColor = document.getElementById('toolbar');
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove('md-transparent');
      } else if (this.extraNavClasses) {
        this.extraNavClasses = '';
        navbarColor.classList.add('md-transparent');
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
  },
  mounted() {
    document.addEventListener('scroll', this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollListener);
  },
};
</script>
<style lang="scss">
.md-toolbar .md-title {
  font-size: 26px!important;
  font-weight: 500!important;
}
.md-toolbar .md-list-item a {
  font-size: 16px;
}
.md-toolbar .md-list-item{
  padding: 0px 15px;
}
.account-name {
  color: black;
  font-weight: bold;
  padding:4px 10px;
  margin:0;
}
.logo {
  width: 100px;
  margin-right: 10px;
}
</style>
